<div class="generalDiv">
  <div class="update-bg">
    <app-background></app-background>
    <div class="update-box">
      <!-- Logo -->
      <div class="update-logo">
        <img src="Logo.svg" alt="Logo" class="auth-logo" />
      </div>

      <p class="update-text">Actualizar contraseña</p>
      <div class="update-container">
        <p class="update-info">Ingresa tu nueva contraseña</p>
        <div class="relative">
          <input
            id="tempPassword"
            [type]="showPasswordTemp() ? 'text' : 'password'"
            class="update-input pr-12"
            placeholder="Ingresar Contraseña"
            required
          />
          <button
            type="button"
            class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600"
            (click)="togglePasswordVisibility('temp')"
          >
            <i class="material-symbols-outlined text-xl">
              {{ showPasswordTemp() ? "visibility_off" : "visibility" }}
            </i>
          </button>
        </div>
      </div>

      <div class="update-b">
        <p class="update-label">Confirma tu contraseña</p>
        <div class="relative">
          <input
            id="newPassword"
            [type]="showPasswordNew() ? 'text' : 'password'"
            class="update-input-b pr-12"
            placeholder="Ingresar Contraseña"
            required
          />
          <button
            type="button"
            class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600"
            (click)="togglePasswordVisibility('new')"
          >
            <i class="material-symbols-outlined text-xl">
              {{ showPasswordNew() ? "visibility_off" : "visibility" }}
            </i>
          </button>
        </div>
      </div>

      <a routerLink="/auth" class="update-btn">
        <div class="update-btn-content">
          <span class="update-btn-text">Guardar</span>
        </div>
      </a>

      <div class="linea"></div>
      <div class="titulo-container">
        <a routerLink="/auth" class="titulo-link">
          <span class="titulo">Iniciar Sesión</span>
        </a>
      </div>
    </div>
  </div>
</div>
